export default function auth({ next }) {
    const authToken = sessionStorage.getItem('authtoken');

    if (!authToken) {
        return next({
            name: 'Login'
        })
    } 
    
    return next()
}